export const products = [
  {
    id: 1,
    name: "Aliquam Consequat",
    category: "Fruits",
    price: 26,
    oldPrice: 362,
    img1: "/img/product/product1.jpg",
    img2: "/img/product/product2.jpg",
    badge: ["Sale", "New"],
  },
  {
    id: 2,
    name: "Donec Non Est",
    category: "Fruits",
    price: 46,
    oldPrice: 382,
    img1: "/img/product/product3.jpg",
    img2: "/img/product/product4.jpg",
    badge: ["Sale"],
  },
  {
    id: 3,
    name: "Etiam Gravida",
    category: "Fruits",
    price: 56,
    oldPrice: 322,
    img1: "/img/product/product5.jpg",
    img2: "/img/product/product6.jpg",
    badge: ["Sale"],
  },
  {
    id: 4,
    name: "Fusce Aliquam",
    category: "Vegetables",
    price: 66,
    oldPrice: 312,
    img1: "/img/product/product7.jpg",
    img2: "/img/product/product8.jpg",
    badge: ["Sale", "New"],
  },
  {
    id: 5,
    name: "Quisque In Arcu",
    category: "Vegetables",
    price: 20,
    oldPrice: 352,
    img1: "/img/product/product9.jpg",
    img2: "/img/product/product10.jpg",
    badge: [],
  },
  {
    id: 6,
    name: "Cas Meque Metus",
    category: "Salads",
    price: 72,
    oldPrice: 352,
    img1: "/img/product/product11.jpg",
    img2: "/img/product/product12.jpg",
    badge: ["New"],
  },
  {
    id: 7,
    name: "Proin Lectus",
    category: "Salads",
    price: 36,
    oldPrice: 282,
    img1: "/img/product/product13.jpg",
    img2: "/img/product/product1.jpg",
    badge: [],
  },
  {
    id: 8,
    name: "Mauris Vel Tellus",
    category: "Vegetables",
    price: 45,
    oldPrice: 162,
    img1: "/img/product/product14.jpg",
    img2: "/img/product/product15.jpg",
    badge: ["Sale"],
  },
  {
    id: 9,
    name: "Sed Volutpat",
    category: "Fruits",
    price: 38,
    oldPrice: 200,
    img1: "/img/product/product16.jpg",
    img2: "/img/product/product17.jpg",
    badge: [],
  },
  {
    id: 10,
    name: "Pellentesque",
    category: "Salads",
    price: 29,
    oldPrice: 150,
    img1: "/img/product/product18.jpg",
    img2: "/img/product/product19.jpg",
    badge: ["New"],
  },
];

export const blogPosts = [
  {
    id: 1,
    title:
      "Lorem ipsum dolor sit amet, elit. Impedit, aliquam animi, saepe ex.",
    date: "23/06/2021",
    cat: "eCommerce",
    img: "/img/blog/blog1.jpg",
  },
  {
    id: 2,
    title:
      "Dolor sit amet, elit. Illo iste sed animi quaerat nobis odit nulla.",
    date: "23/06/2021",
    cat: "eCommerce",
    img: "/img/blog/blog2.jpg",
  },
  {
    id: 3,
    title: "Maxime laborum voluptas minus, est, unde eaque esse tenetur.",
    date: "23/06/2021",
    cat: "eCommerce",
    img: "/img/blog/blog3.jpg",
  },
  {
    id: 4,
    title:
      "Lorem ipsum dolor sit amet, elit. Impedit, aliquam animi, saepe ex.",
    date: "23/06/2021",
    cat: "eCommerce",
    img: "/img/blog/blog2.jpg",
  },
];

// export const sliders = [
//   { id: 1, img: `${process.env.PUBLIC_URL}/img/product/fruits1.jpeg`, h1: 'Fresh Organic Fruit', h2: 'Tomatoes, Onions & Garlic', text: '10% certified-organic mix of fruit and veggies. Perfect for weekly cooking and snacking!' },
//   { id: 2, img: '/img/product/videoblocks-composition-of-dried-fruits-and-nuts-in-small-wicker-bowl-placed-on-a-stone-tabl.png', h1: 'Premium  Dry Fruits ', h2: 'Natural Farm Products', text: 'Widest range of farm-fresh Vegetables, Fruits & seasonal produce' },
//   { id: 3, img: '/img/product/dark-mood-food-vegetables-lichtspiel-rembrandt-light-b91f348862576e1509603a6e1faba180.jpg', h1: 'Fresh Vagitable ', h2: 'Cabbage, Root Vegetables', text: 'Natural organic tomatoes make your health stronger.' },
// ];
export const sliders = [
  {
    id: 1,
    img: `${process.env.PUBLIC_URL}/img/product/OIKuA7zwis7QXQGDGcgoz67ZzOvgoOMRbg9QdBxt.png`,
    h1: "Industrial & Agri Oils",
    // h2: "Tomatoes, Onions & Garlic",
    text: "Perfect for heavy-duty lubrication, agricultural machinery, and various processing operations.",
  },
  {
    id: 2,
    img: `${process.env.PUBLIC_URL}/img/product/mOfkGJntTpMtqysLL4RvVY1mx3V50pxNSMIKyZzM.webp`,
    h1: "Premium Dehydrated Products",
    // h2: "Natural Farm products",
    text: "Widest range of farm-fresh Vegetables, Fruits & seasonal produce",
  },
  {
    id: 3,
    img: `${process.env.PUBLIC_URL}/img/product/Gemini_Generated_Image_kb43hfkb43hfkb43.png`,
    h1: "Pulses and Cereals",
    // h2: "Cabbage, Root Pulses",
    text: "Premium quality staples for exquisite everyday meals.",
  },
];

export const brands = [
  `${process.env.PUBLIC_URL}/img/brand/brand1.jpg`,
  `${process.env.PUBLIC_URL}/img/brand/brand2.jpg`,
  `${process.env.PUBLIC_URL}/img/brand/brand3.jpg`,
  `${process.env.PUBLIC_URL}/img/brand/brand4.jpg`,
  `${process.env.PUBLIC_URL}/img/brand/brand2.jpg`,
];

export const navMenu = [
  // { label: 'Home', href: '/' },
  // {
  //   label: 'Shop', href: '/shop',
  //   children: [
  //     { label: 'Shop List', href: '/shop-list' },
  //     { label: 'Product Details', href: '/product-details' },
  //     { label: 'Product Grouped', href: '/product-grouped' },
  //     { label: 'Product Sidebar', href: '/product-sidebar' },
  //   ]
  // },
  {
    label: "Blog",
    href: "/blog",
    // children: [
    //   { label: 'Blog Details', href: `/blog-details` },
    //   { label: 'Blog Sidebar', href: '/blog-sidebar' },
    // ]
  },
  // {
  //   label: 'Pages', href: '#',
  //   children: [
  //     { label: 'About Us', href: '/about' },
  //     { label: 'FAQ', href: '/faq' },
  //   ]
  // },
  { label: "Contact Us", href: "/contact" },
  { label: "Private Label", href: "/packaging-private-labelling" },
  // { label: "Brochure", href: "/brochure" },
];
export const mobileMenu = [
  // { label: 'Home', href: '/' },
  // {
  //   label: 'Shop', href: '/shop',
  //   children: [
  //     { label: 'Shop List', href: '/shop-list' },
  //     { label: 'Product Details', href: '/product-details' },
  //     { label: 'Product Grouped', href: '/product-grouped' },
  //     { label: 'Product Sidebar', href: '/product-sidebar' },
  //   ]
  // },
  {
    label: "Blog",
    href: "/blog",
    // children: [
    //   { label: 'Blog Details', href: `/blog-details` },
    //   { label: 'Blog Sidebar', href: '/blog-sidebar' },
    // ]
  },
  // {
  //   label: 'Pages', href: '#',
  //   children: [
  //     { label: 'About Us', href: '/about' },
  //     { label: 'FAQ', href: '/faq' },
  //   ]
  // },
  { label: "Contact Us", href: "/contact" },
  { label: "Private Label", href: "/packaging-private-labelling" },
  // { label: "Brochure", href: "/brochure" },
];
